export function saveToStorage(key: string, object: any) {
    localStorage.setItem(key, JSON.stringify(object));
}

export function loadFromStorage(key: string): any {
    return JSON.parse(localStorage.getItem(key));
}
